import * as React from "react";
import { SVGProps } from "react";
const SvgClock = (props: SVGProps<SVGSVGElement>) => <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><g transform="translate(1 1)" stroke="currentColor" fill="none" fillRule="evenodd"><circle cx={11} cy={11} r={11} /><path d="M10.364 3.69V11h4.896" /></g></svg>;
export default SvgClock;